<template>
    <h4 class="text-foreground text-xl font-semibold tracking-tight leading-7 ">
        <slot/>
    </h4>
</template>